document.addEventListener('DOMContentLoaded', function() {
  const dynamicOptionValueElement = document.querySelector('[data-dynamic-option-value]');
  const dynamicOptionValue = dynamicOptionValueElement.textContent;
  const optionValues = document.querySelectorAll('.variant-picker__option-values [data-hover-label]');

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const updateDynamicOptionValue = debounce(function(text) {
    if (dynamicOptionValueElement) {
      dynamicOptionValueElement.textContent = text;
    }
  }, 50);

  optionValues.forEach(function(optionValue) {
    optionValue.addEventListener('mouseenter', function() {
      updateDynamicOptionValue(this.getAttribute('data-hover-label'));
    });

    optionValue.addEventListener('mouseleave', function() {
      updateDynamicOptionValue(dynamicOptionValue);
    });
  });
});